var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.7778,
    height: 41.7778,
    rx: 20,
    fill: "#6EE796"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7609 17.9876C9.05892 17.9876 8.7037 18.3216 8.7037 19.9217V22.823C8.7037 24.4233 9.05892 24.7571 10.7609 24.7571H14.8754V36.3621C14.8754 37.9622 15.2306 38.2963 16.9327 38.2963H21.0471C22.7492 38.2963 23.1043 37.9622 23.1043 36.3621V24.7571H27.7243C29.0152 24.7571 29.3478 24.5213 29.7024 23.3544L30.5841 20.4531C31.1915 18.4543 30.8172 17.9876 28.6059 17.9876H23.1043V13.1522C23.1043 12.084 24.0254 11.2181 25.1615 11.2181H31.0169C32.7188 11.2181 33.0741 10.8841 33.0741 9.28391V5.4156C33.0741 3.81541 32.7188 3.48145 31.0169 3.48145H25.1615C19.4806 3.48145 14.8754 7.81121 14.8754 13.1522V17.9876H10.7609Z",
    stroke: "black",
    strokeWidth: 2.61111,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.532da00656b8d2304e95976fe6bb1367.svg";
export { ForwardRef as ReactComponent };